/**
 * Created by sswaminathan on 1/9/22
 * File: CheckBoxComponent
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Body, Bold } from '@panwds/react-ui'
import { Checkbox } from '@panwds/react-form-legacy'
import { groupBy } from 'lodash'
import { useState, useEffect, useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { GetValidation } from '../../../common/actions/GlobalActions'
import { FF_ALLOW_DISABLE_ADDON } from '../../../common/utils/FeatureFlags'
import { getVarValue } from '../../../common/utils/Sparky'
import { SUBSCRIPTION_ACTION_EDIT, USER_ACTION_REQUIRED } from '../constants/SubscriptionConstant'

const allowDisableFlag = getVarValue(FF_ALLOW_DISABLE_ADDON, false)

const CheckBoxComponent = (props) => {
  const { checkBoxLabelDesc,
    label,
    allowDisable = false,
    allocation = true,
    app_id,
    productInformation = [],
    selectedTreeNode,
    setValidationAppList,
    licenseValue,
    setValidation,
    validationAppList = [],
    product,
    product_dual,
    setCheckBoxStatus,
    isBundle,
    licenseAction,
    licenseInfo,
    isSingleTenant = false,
    dispatch } = props
  const [checkBoxState, setCheckBoxState] = useState(true)
  const { setValue, getValues, trigger } = useFormContext()
  const checkBoxName = !isBundle ? product?.checkBox : `${product?.checkBox}_bundle`
  useEffect(() => {
    if (USER_ACTION_REQUIRED.has(app_id)) {
      if (!getValues(checkBoxName)) {
        setCheckBoxState((licenseAction === SUBSCRIPTION_ACTION_EDIT && licenseInfo[app_id]))
        setValue(checkBoxName, (licenseAction === SUBSCRIPTION_ACTION_EDIT && licenseInfo[app_id]))
      }
      else {
        setCheckBoxState(getValues(checkBoxName))
        setValue(checkBoxName, getValues(checkBoxName))
      }
    }
    else if (isBundle) {
      setCheckBoxState(true)
    }
    else if (allocation) {
      setCheckBoxState(true)
      // TODO: This is set explicit to fix the auto select on deselected apps.
      setValue(checkBoxName, true)
    }
  }, [allocation, app_id, checkBoxName, getValues, isBundle, licenseAction, licenseInfo, setCheckBoxStatus, setValue])

  /**
   *  To invoke the validation api based on the select and deselect of addons
   * @type {(function(): Promise<void>)|*}
   */

  const changeHandler = useCallback(async () => {
    if (!isSingleTenant) {
      product_dual && setValue(product_dual?.checkBox, !checkBoxState)
      setCheckBoxStatus(getValues(product?.checkBox))
      const validationRequest = {
        appList: [...validationAppList]
      }
      if (!checkBoxState) {
        validationRequest.appList.push(app_id)
      }
      else {
        validationRequest.appList = validationRequest.appList.filter((each) => each !== app_id)
      }
      const request = {
        input: productInformation[0]?.validationRequest?.filter((elem) => validationRequest.appList.includes(elem.app_id))
      }
      if (setValidationAppList && typeof setValidationAppList === 'function') {
        setValidationAppList(Object.keys(groupBy(request.input, 'app_id')))
      }
      const response = await GetValidation(request, selectedTreeNode?.id, dispatch)
      if (setValidation && typeof setValidation === 'function') {
        setValidation((prev) => {
          const preValue = { ...prev }
          preValue[licenseValue] = response
          return preValue
        })
      }
      trigger()
    }
  }, [app_id, checkBoxState, dispatch, getValues, isSingleTenant, licenseValue,
    product?.checkBox, productInformation, product_dual, selectedTreeNode?.id, setCheckBoxStatus,
    setValidation, setValidationAppList, setValue, trigger, validationAppList])

  return (
    <div className={`tw-flex tw-flex-col ${isSingleTenant ? '' : 'tw-pl-2'}`} style={{ flexBasis: '38%' }}>
      <div className="tw-flex tw-items-center tw-flex-1 tw-gap-2">
        <Checkbox
          label={label}
          name={checkBoxName}
          showLabel={false}
          defaultValue={checkBoxState}
          disabled={!allowDisableFlag || !allowDisable}
          register={{
            //value: checkBoxState,
            required: false,
            onChange: () => {
              setCheckBoxState(!checkBoxState)
              changeHandler()
            }
          }
          }
        />
        <Bold
          addClassName={`${isSingleTenant ? '' : 'tw-pl-2'} tw-text-xs tw-pt-2`}>
          {`${label}${!isBundle ? '' : ' Bundle'}`}
        </Bold>
      </div>
      {
        checkBoxLabelDesc?.length > 0 &&
        <Body size="md" addClassName="tw-pl-8" appearance="secondary">
          {checkBoxLabelDesc}
        </Body>
      }
    </div >
  )
}

CheckBoxComponent.propTypes = {}
export default CheckBoxComponent
